import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Button, Spinner } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import BreadcrumbSection from "components/BreadcrumbSection";
import { categoryAllResourceListing } from "api/CategoryService";
import { stripHtmlTags } from "utils/helpers";
import { useNavigate } from "react-router-dom";
const AllResources = () => {
  const { id } = useParams();
  const [resources, setResources] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 9;
  const [hasMore, setHasMore] = useState(true);
  const [categoryTitle, setCategoryTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      fetchCategoryResources(true);
    }
  }, [id]);

  const fetchCategoryResources = async (reset = false) => {
    try {
      setLoading(true);
      const currentPage = reset ? 1 : page;
      const res = await categoryAllResourceListing(id, currentPage, limit);
  
      if (res.success) {
        const newData = res.body.data || [];
        setCategoryTitle(newData[0]?.postCategoryId.title);
        const totalPages = res.body.total_pages || 1;
  
        setResources(prev =>
          reset ? newData : [...prev, ...newData]
        );
  
        setHasMore(currentPage < totalPages);  // ✅ Correct page used
        setPage(currentPage + 1);              // ✅ Increment after check
      }else {
        navigate("/not-found");
      }
    } catch (err) {
      console.error("Failed to fetch resources by category:", err);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <BreadcrumbSection
        breadcrumbs={[
          { title: "Resources", link: "/resources" },
          { title: categoryTitle || "All" },
        ]}
      />

      <section className="software_section py-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="software_header mb-4">
                <h2>All Resources {categoryTitle && `— ${categoryTitle}`}</h2>
              </div>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              <Row>
                {resources.length > 0 ? (
                  resources.map((card, index) => (
                    <Col md={6} lg={4} sm={12} key={index} className="mb-4">
                      <Card className="h-100 res_Card">
                        <Link to={`/resources-details/${card._id}`} target="_blank">
                          <Card.Img variant="top" src={card.mediaUrl} />
                        </Link>
                        <Card.Body>
                          <Card.Text className="tag">{card.tag}</Card.Text>
                          <Link to={`/resources-details/${card._id}`} target="_blank">
                            <Card.Title>{card.title}</Card.Title>
                          </Link>
                          <Card.Text className="para">
                            {stripHtmlTags(card.description)?.slice(0, 100)}...
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col>
                    <p>No resources found for this category.</p>
                  </Col>
                )}
              </Row>

              {hasMore && (
                <div className="text-center mt-3">
                  <Button variant="outline-info" onClick={() => fetchCategoryResources()}>
                    Load More
                  </Button>
                </div>
              )}
            </>
          )}
        </Container>
      </section>
    </>
  );
};

export default AllResources;
